import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
export const initialStateBanner = {
  noticeEmbeddedApp: true,
  showThingsToDoNext: true,
  showRecommendActions: true,
  showReferApp: true,
  showHolidayNotice: true,
  showBannerLimitPopup: true,
  showBannerLimitTranslation: true,
  showBannerLimitCheckoutVerification: true,
  showBannerLimitTermAndCondition: true,
};

export const bannerSlice = createSlice({
  name: 'banner',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: initialStateBanner,
  reducers: {
    // handleVisibleBanner: (
    //   state,
    //   action: PayloadAction<{
    //     key: keyof typeof initialState;
    //     value: boolean;
    //   }>,
    // ) => {
    //   state[action.payload.key] = action.payload.value;
    // },
    handleBannerNoticeEmbeddedApp: (state, action: PayloadAction<boolean>) => {
      state.noticeEmbeddedApp = action.payload;
    },
    handleShowThingsToDoNext: (state, action: PayloadAction<boolean>) => {
      state.showThingsToDoNext = action.payload;
    },
    handleShowRecommendActions: (state, action: PayloadAction<boolean>) => {
      state.showRecommendActions = action.payload;
    },
    handleShowReferApp: (state, action: PayloadAction<boolean>) => {
      state.showReferApp = action.payload;
    },
    handleShowHolidayNotice: (state, action: PayloadAction<boolean>) => {
      state.showHolidayNotice = action.payload;
    },
    handleStateBanner: (state, action: PayloadAction<{ key: keyof typeof initialStateBanner; value: boolean }>) => {
      state[action.payload.key] = action.payload.value;
    },
  },
});
export const bannerNoticeEmbeddedAppSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.noticeEmbeddedApp,
);
export const showThingsToDoNextSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showThingsToDoNext,
);
export const showRecommendActionSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showRecommendActions,
);
export const showReferAppSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showReferApp,
);

export const showHolidayNoticeSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showHolidayNotice,
);

export const showBannerLimitPopupSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showBannerLimitPopup,
);

export const showBannerLimitTranslationSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showBannerLimitTranslation,
);

export const showBannerLimitCheckoutVerificationSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showBannerLimitCheckoutVerification,
);

export const showBannerLimitTermAndConditionSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.showBannerLimitTermAndCondition,
);

export const { handleStateBanner } = bannerSlice.actions;

export default bannerSlice;
